class Parametrizacao {
    constructor(id, internacionalizacao, dadosInformativos){
        this.id = id;
        this.internacionalizacao = JSON.parse(nome);
        this.dadosInformativos = JSON.parse(sigla);
    }
}

export default Parametrizacao;
